import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";

const PublicRoute = () => {
  const navigate = useNavigate();
  const { userData } = useSelector((state) => state.user);

  useEffect(() => {
    const token = localStorage.getItem("authToken");

    if (token && userData?.role === "admin") {
      navigate("/admin/dashboard");
    }

    if (token && userData?.role === "user") {
      navigate("/dashboard");
    }
  }, [navigate]);

  return <Outlet />;
};

export default PublicRoute;
